import React, { Component } from 'react';
import { ResearcherForm } from './ResearcherForm';

export class AddResearcher extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <h1>Add a Researcher</h1>
                <ResearcherForm />
            </div>
        )
    }
}